import { FC, useCallback, useState } from 'react'

import { ErrorBoundary } from '@/components/ui/ErrorBoundary/ErrorBoundary'

import { SidebarContainer } from './SidebarContainer'
import { SidebarContent } from './SidebarContent'

export interface ChattingSidebarProps {
  isMobileSidebarOpen: boolean
  closeMobileSidebar: () => void
}

export const ChattingSidebar: FC<ChattingSidebarProps> = ({
  isMobileSidebarOpen,
  closeMobileSidebar,
}) => {
  const [isExpanded, setIsExpanded] = useState(true)

  const handleError = useCallback(() => {
    setIsExpanded(true)
  }, [])

  return (
    <SidebarContainer
      isExpanded={isExpanded}
      isMobileSidebarOpen={isMobileSidebarOpen}
    >
      <ErrorBoundary
        boundaryName="ChattingSidebar"
        fallbackTemplate="module"
        onError={handleError}
      >
        <SidebarContent
          isMobileSidebarOpen={isMobileSidebarOpen}
          closeMobileSidebar={closeMobileSidebar}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
        />
      </ErrorBoundary>
    </SidebarContainer>
  )
}
